export default __webpack_public_path__ + "media/software-development.4dbc561b7db97aaf35ae3db1e9d0606a.svg";